const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;

const ANIMAL_TYPES: Record<PetType, string> = {
  dog: 'Perro',
  cat: 'Gato',
};

const ANIMAL_AGES_CHOICES: Record<PetAges, string> = {
  baby: 'Cachorro',
  young: 'Joven',
  adult: 'Adulto',
  senior: 'Senior',
};

const ANIMAL_GENDERS: Record<'m' | 'f', string> = {
  m: 'Macho',
  f: 'Hembra',
};

const DOG_RACES = [
  'Akita Inu',
  'Alaskan Malamute',
  'Basset Hound',
  'Beagle',
  'Border Collie',
  'Boxer',
  'Bulldog Francés',
  'Bulldog Inglés',
  'Bretón (Epagneul Breton)',
  'Cane Corso',
  'Chihuahua',
  'Cocker Spaniel',
  'Dachshund (Salchicha)',
  'Dálmata',
  'Doberman',
  'Dogo Argentino',
  'Fox Terrier',
  'Golden Retriever',
  'Gran Danés',
  'Husky Siberiano',
  'Jack Russell Terrier',
  'Labrador Retriever',
  'Mastín Napolitano',
  'Ovejero Alemán (Pastor Alemán)',
  'Ovejero Australiano (Australian Shepherd)',
  'Pastor Belga Malinois',
  'Pitbull (American Pit Bull Terrier)',
  'Poodle (Caniche)',
  'Pug',
  'Rottweiler',
  'San Bernardo',
  'Schnauzer',
  'Shar Pei',
  'Shiba Inu',
  'Shih Tzu',
  'Weimaraner',
  'Yorkshire Terrier',
  'Otra',
];

const CAT_RACES = [
  'Angora Turco',
  'Azul Ruso',
  'Bengalí',
  'British Shorthair',
  'Maine Coon',
  'Persa',
  'Ragdoll',
  'Scottish Fold',
  'Siamés',
  'Tabby Point',
  'Siberiano',
  'Otra',
];

const PUBLISH_PET_FIELDS_TRANSLATIONS: Record<keyof Omit<Pet, 'solved_case'>, string> = {
  id: 'ID',
  gallery: 'Galería',
  status: 'Estado',
  type: 'Tipo',
  date_found: 'Fecha',
  date_lost: 'Fecha',
  name: 'Nombre',
  sterilized: 'Esterilizada',
  gender: 'Genero',
  age: 'Edad',
  main_color: 'Color principal',
  race: 'Raza',
  location: 'Ubicación',
  observations: 'Observaciones',
  uploaded_by: 'Subido por',
  retained: 'Retenida',
};

const PET_AGES_LABELS = {
  baby: 'cachorro (0 a 6 meses)',
  young: 'joven (6 meses a 2 años)',
  adult: 'adulto (2 a 7 años)',
  senior: 'senior (+7 años)',
};

const PET_GENDER: Record<PetGender, string> = {
  m: 'Macho',
  f: 'Hembra',
};

const ANIMAL_AGES: Record<PetAges, string> = {
  baby: 'Cachorro',
  young: 'Joven',
  adult: 'Adulto',
  senior: 'Senior',
};

const PET_COLORS: Record<string, string> = {
  negro: 'Negro',
  blanco: 'Blanco',
  naranja: 'Naranja',
  gris: 'Gris',
  marron: 'Marrón',
  crema: 'Crema / Beige',
  atigrado: 'Atigrado',
  multicolor: 'Multicolor / Manchado',
};

export {
  SENTRY_DSN,
  CAT_RACES,
  DOG_RACES,
  API_BASE_URL,
  ANIMAL_TYPES,
  ANIMAL_AGES_CHOICES,
  ANIMAL_GENDERS,
  PUBLISH_PET_FIELDS_TRANSLATIONS,
  PET_AGES_LABELS,
  PET_GENDER,
  ANIMAL_AGES,
  PET_COLORS,
};
